import { render, staticRenderFns } from "./a1.vue?vue&type=template&id=f39147c4&scoped=true&"
import script from "./a1.vue?vue&type=script&lang=js&"
export * from "./a1.vue?vue&type=script&lang=js&"
import style0 from "./a1.vue?vue&type=style&index=0&id=f39147c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39147c4",
  null
  
)

export default component.exports